import {BulmaMenu} from "./module/bulma-menu.js";
import {BulmaDropdown} from "./module/bulma-dropdown.js";
import {BulmaModal} from "./module/bulma-modal.js";
import {ShowPassword} from "./module/show-password.js";
import {FlashMessages} from "./module/flash-messages.js";
import {SecureEmail} from "./module/secure-email.js";
import {SecurePhone} from "./module/secure-phone.js";
import {ForClipboard} from "./module/for-clipboard.js";
import {ForShare} from "./module/for-share.js";
import {StyledSelect} from "./module/styled-select.js";
import {ToggleVisibility} from "./module/toggle-visibility.js";
import {MarkdownEditor} from "./module/markdown-editor.js";
import {GameCreateForm} from "./module/game-create-from.js";
import {WebPush} from "./module/web-push.js";
import {UrlHistoryManager} from "./module/url-history-manager.js";
import {TableFilter} from "./module/table-filter.js";
import StyledMultiSelect from "./module/styled-multi-select.js";
import StyledNumberInput from "./module/styled-number-input.js";

BulmaMenu.init({});
BulmaDropdown.init({});
BulmaModal.init({});
MarkdownEditor.init({});
ShowPassword.init({});
FlashMessages.init({});
SecureEmail.init({});
SecurePhone.init({});
ForClipboard.init({});
ForShare.init({});
StyledSelect.init({});
ToggleVisibility.init({});
GameCreateForm.init({});
WebPush.init(webPushConfig);
const urlHistoryManager = new UrlHistoryManager({});
const tableFilter = new TableFilter({});
const styledMultiSelect = new StyledMultiSelect({});
const styledNumberInput = new StyledNumberInput({});

// enable after htmx
htmx.onLoad(function (element) {
    BulmaMenu.initSelectors(element);
    BulmaDropdown.initSelectors(element);
    BulmaModal.initSelectors(element);
    MarkdownEditor.initSelectors(element);
    ShowPassword.initSelectors(element);
    FlashMessages.initSelectors(element);
    SecureEmail.initSelectors(element);
    SecurePhone.initSelectors(element);
    ForClipboard.initSelectors(element);
    ForShare.initSelectors(element);
    StyledSelect.initSelectors(element);
    ToggleVisibility.initSelectors(element);
    GameCreateForm.initSelectors(element);
    urlHistoryManager.initSelectors(element);
    tableFilter.initSelectors(element);
    styledMultiSelect.initSelectors(element);
    styledNumberInput.initSelectors(element);
});